import { render, staticRenderFns } from "./MediaListComponent.vue?vue&type=template&id=3ad618ec"
import script from "./MediaListComponent.vue?vue&type=script&lang=ts"
export * from "./MediaListComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports